module.exports = __webpack_public_path__ + "img/monster-mouth.bfa5a3d4.png";